import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import FilterListIcon from '@mui/icons-material/FilterList'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import React from 'react'

import SingleChoice from '@/app/component/atom/filters/single-choice'
import { useIsMobile } from '@/app/hooks/use-is-mobile'
import { SubscriptionFilter } from '@/app/module/campaigns/types/subscriptions'
import { type SelectOption } from '@/app/types'

type Props = {
  subscriptionFilter?: SubscriptionFilter

  onChange: (filter: SubscriptionFilter) => void
}

const ResponsiveSubFilter: React.FC<Props> = (props) => {
  const { subscriptionFilter = SubscriptionFilter.All, onChange } = props
  const isMobile = useIsMobile()
  const anchorEl = React.useRef<HTMLDivElement | null>(null)
  const [open, setOpen] = React.useState(false)

  const selected = React.useMemo(
    () => filterOptions.find((option) => option.value === subscriptionFilter),
    [subscriptionFilter],
  )

  return (
    <div ref={anchorEl}>
      {isMobile ? (
        <IconButton
          aria-label={`Filter subscriptions by status: ${selected?.label || 'Subscription status'}`}
          color={subscriptionFilter === SubscriptionFilter.All ? 'default' : 'primary'}
          onClick={() => setOpen(true)}
        >
          <FilterListIcon />
        </IconButton>
      ) : (
        <Button
          endIcon={<ArrowDropDownIcon />}
          startIcon={<FilterListIcon />}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
          }}
          variant="outlined"
          onClick={() => setOpen(true)}
        >
          {selected?.label || 'Subscription status'}
        </Button>
      )}
      <Menu id="subscriptions-filter-menu" anchorEl={anchorEl.current} open={open} onClose={() => setOpen(false)}>
        <SingleChoice
          name="subscriptions-filter"
          options={filterOptions}
          value={subscriptionFilter}
          onChange={(value) => {
            onChange(value as SubscriptionFilter)
            setOpen(false)
          }}
        />
      </Menu>
    </div>
  )
}

const filterOptions: SelectOption<SubscriptionFilter>[] = [
  {
    label: 'All contacts',
    value: SubscriptionFilter.All,
  },
  {
    label: 'Subscribed',
    value: SubscriptionFilter.IsSubscribed,
  },
  {
    label: 'Not subscribed',
    value: SubscriptionFilter.IsNotSubscribed,
  },
  {
    label: 'Was subscribed',
    value: SubscriptionFilter.WasSubscribed,
  },
]

export default ResponsiveSubFilter
